import AirDatepicker from 'air-datepicker';
import 'air-datepicker/air-datepicker.css';
import localeEn from 'air-datepicker/locale/en';
import localeDe from 'air-datepicker/locale/de';

var config = {};
if (document.documentElement.lang === 'de') {
    config.locale = localeDe;
} else {
    config.locale = localeEn;
}

document.querySelectorAll('.datepicker-input').forEach(input => {
    new AirDatepicker(input, config);
});
